// Generated code; do not edit.
// You might be looking for: packages/bank-schemas/bank.graphql
// To regenerate: yarn workspaces foreach -A run generate-types

import type * as Types from '../../gqltypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import {
  EventItemFragmentDoc,
  ReceiptItemFragmentDoc,
  AnnotationItemFragmentDoc,
  LedgerCategoryInfoItemFragmentDoc,
} from '../../common-client-queries.generated';
export type AddressBookContactItemFragment = {
  readonly __typename: 'AddressBookContact';
  readonly fid: string;
  readonly accountNumber: string;
  readonly name: string;
  readonly streetAddress: string;
  readonly postalCode: string;
  readonly postalPlace: string;
  readonly country: string;
  readonly used: number;
  readonly lastTransactionDate: string;
  readonly lastCurrencyCode: string | null;
};

export type PaymentInfoFragment = {
  readonly __typename: 'PaymentInfo';
  readonly paymentFid: string;
  readonly createdAt: string;
  readonly creditorName: string;
  readonly creditorAccount: string;
  readonly creditorEarmarkFid: string | null;
  readonly formattedCreditorAccount: string;
  readonly confirmed: boolean;
  readonly formattedDebtorAccount: string;
  readonly debtorAccount: string;
  readonly debtorAccountName: string | null;
  readonly debtorEarmarkFid: string | null;
  readonly amount: string;
  readonly fee: string | null;
  readonly currencyCode: string;
  readonly executionDate: string;
  readonly kid: string | null;
  readonly message: string | null;
  readonly status: Types.PaymentStatus;
  readonly canBeDeleted: boolean;
  readonly external: boolean;
  readonly immutable: boolean;
  readonly isFolioInvoice: boolean;
  readonly canBeBatchApproved: boolean;
  readonly estimatedNokAmount: {
    readonly __typename: 'AmountInfo';
    readonly asNumber: number;
  } | null;
  readonly createdBy: {
    readonly __typename: 'Agent';
    readonly fid: string;
    readonly structuredName: {
      readonly __typename: 'Name';
      readonly full: string;
      readonly first: string | null;
    };
  } | null;
  readonly event: {
    readonly __typename: 'Event';
    readonly fid: string;
    readonly dateTime: string;
    readonly movementType: Types.MovementType;
    readonly title: string;
    readonly description: string;
    readonly subtitle: string | null;
    readonly infoLine: string | null;
    readonly icon: string | null;
    readonly bulkPaymentFid: string | null;
    readonly currencyAmount: string | null;
    readonly currencyCode: string | null;
    readonly amount: string | null;
    readonly physicalTerminal: boolean;
    readonly isInvoice: boolean;
    readonly isOwnCardEvent: boolean;
    readonly completed: boolean;
    readonly isEditable: boolean;
    readonly card: {
      readonly __typename: 'Card';
      readonly fid: string;
      readonly name: string | null;
    } | null;
    readonly account: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly name: string;
    } | null;
    readonly transaction: {
      readonly __typename: 'EventTransaction';
      readonly fid: string;
      readonly remittanceInformation: string | null;
      readonly debtorAccountNumber: string | null;
      readonly creditorAccountNumber: string | null;
      readonly kid: string | null;
      readonly bookingDate: string | null;
      readonly isPending: boolean;
    } | null;
    readonly payment: {
      readonly __typename: 'PaymentInfo';
      readonly paymentFid: string;
      readonly status: Types.PaymentStatus;
      readonly kid: string | null;
      readonly message: string | null;
      readonly debtorAccount: string;
      readonly creditorAccount: string;
      readonly isTaxPayment: boolean;
      readonly external: boolean;
      readonly fee: string | null;
      readonly createdBy: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
      readonly signedBy: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
      readonly accountingSystemInformation: {
        readonly __typename: 'AccountingSystemPaymentInformation';
        readonly systemName: string;
        readonly ledgerAccount: number | null;
        readonly externalURL: string | null;
      } | null;
    } | null;
    readonly merchant: {
      readonly __typename: 'Merchant';
      readonly fid: string;
      readonly name: string;
    } | null;
    readonly receipts: ReadonlyArray<{
      readonly __typename: 'Receipt';
      readonly fid: string;
      readonly mime: string;
      readonly uploadedAt: string;
      readonly userData: string | null;
      readonly isInvoice: boolean;
      readonly receiptLooksValid: boolean;
      readonly images: {
        readonly __typename: 'ReceiptImages';
        readonly color: string;
        readonly originalUrl: string;
        readonly croppedUrl: string | null;
        readonly thumbnail128Url: string | null;
        readonly thumbnail256Url: string | null;
        readonly thumbnail512Url: string | null;
      };
    }>;
    readonly note: {
      readonly __typename: 'Annotation';
      readonly fid: string;
      readonly dateTime: string;
      readonly text: string;
      readonly agentInfo: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
    } | null;
    readonly purpose: {
      readonly __typename: 'Annotation';
      readonly fid: string;
      readonly dateTime: string;
      readonly text: string;
      readonly agentInfo: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
    } | null;
    readonly participants: {
      readonly __typename: 'Annotation';
      readonly fid: string;
      readonly dateTime: string;
      readonly text: string;
      readonly agentInfo: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
    } | null;
    readonly receiptNotNeeded: {
      readonly __typename: 'Annotation';
      readonly fid: string;
      readonly dateTime: string;
      readonly text: string;
      readonly agentInfo: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
    } | null;
    readonly receiptLost: {
      readonly __typename: 'Annotation';
      readonly fid: string;
      readonly dateTime: string;
      readonly text: string;
      readonly agentInfo: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
    } | null;
    readonly requirements: {
      readonly __typename: 'EventRequirements';
      readonly metRequirementCount: number;
      readonly totalRequirementCount: number;
      readonly allRequirementsMet: boolean;
      readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
      readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
      readonly requirementsOverridden: {
        readonly __typename: 'RequirementsOverriddenInfo';
        readonly overridden: boolean;
        readonly accountingSystem: string | null;
      };
    };
    readonly ledgerCategoryInfo: {
      readonly __typename: 'LedgerCategoryInfo';
      readonly kind: Types.LedgerCategoryInfoKind;
      readonly category: {
        readonly __typename: 'LedgerCategoryItem';
        readonly fid: string;
        readonly title: string;
        readonly subtitle: string | null;
        readonly icon: Types.LedgerCategoryIcon;
        readonly synonyms: ReadonlyArray<string>;
        readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
      } | null;
      readonly guesses: ReadonlyArray<{
        readonly __typename: 'LedgerCategoryItem';
        readonly fid: string;
      }>;
    };
  };
  readonly addressBookContact: {
    readonly __typename: 'AddressBookContact';
    readonly fid: string;
    readonly accountNumber: string;
    readonly name: string;
    readonly streetAddress: string;
    readonly postalCode: string;
    readonly postalPlace: string;
    readonly country: string;
    readonly used: number;
    readonly lastTransactionDate: string;
    readonly lastCurrencyCode: string | null;
  } | null;
  readonly signedBy: {
    readonly __typename: 'Agent';
    readonly fid: string;
    readonly structuredName: {
      readonly __typename: 'Name';
      readonly full: string;
      readonly first: string | null;
    };
  } | null;
  readonly accountingSystemInformation: {
    readonly __typename: 'AccountingSystemPaymentInformation';
    readonly systemName: string;
    readonly registeredBy: string | null;
    readonly ledgerAccount: number | null;
  } | null;
};

export type SalaryPaymentInfoFragment = {
  readonly __typename: 'SalaryPayment';
  readonly fid: string;
  readonly amount: string;
  readonly executionDate: string;
  readonly bulkStatus: Types.SalaryPaymentStatus;
  readonly status: Types.PaymentStatus;
  readonly externalId: string | null;
  readonly payments: ReadonlyArray<{
    readonly __typename: 'PaymentInfo';
    readonly paymentFid: string;
    readonly createdAt: string;
    readonly creditorName: string;
    readonly creditorAccount: string;
    readonly creditorEarmarkFid: string | null;
    readonly formattedCreditorAccount: string;
    readonly confirmed: boolean;
    readonly formattedDebtorAccount: string;
    readonly debtorAccount: string;
    readonly debtorAccountName: string | null;
    readonly debtorEarmarkFid: string | null;
    readonly amount: string;
    readonly fee: string | null;
    readonly currencyCode: string;
    readonly executionDate: string;
    readonly kid: string | null;
    readonly message: string | null;
    readonly status: Types.PaymentStatus;
    readonly canBeDeleted: boolean;
    readonly external: boolean;
    readonly immutable: boolean;
    readonly isFolioInvoice: boolean;
    readonly canBeBatchApproved: boolean;
    readonly estimatedNokAmount: {
      readonly __typename: 'AmountInfo';
      readonly asNumber: number;
    } | null;
    readonly createdBy: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
    readonly event: {
      readonly __typename: 'Event';
      readonly fid: string;
      readonly dateTime: string;
      readonly movementType: Types.MovementType;
      readonly title: string;
      readonly description: string;
      readonly subtitle: string | null;
      readonly infoLine: string | null;
      readonly icon: string | null;
      readonly bulkPaymentFid: string | null;
      readonly currencyAmount: string | null;
      readonly currencyCode: string | null;
      readonly amount: string | null;
      readonly physicalTerminal: boolean;
      readonly isInvoice: boolean;
      readonly isOwnCardEvent: boolean;
      readonly completed: boolean;
      readonly isEditable: boolean;
      readonly card: {
        readonly __typename: 'Card';
        readonly fid: string;
        readonly name: string | null;
      } | null;
      readonly account: {
        readonly __typename: 'Account';
        readonly accountNumber: string;
        readonly name: string;
      } | null;
      readonly transaction: {
        readonly __typename: 'EventTransaction';
        readonly fid: string;
        readonly remittanceInformation: string | null;
        readonly debtorAccountNumber: string | null;
        readonly creditorAccountNumber: string | null;
        readonly kid: string | null;
        readonly bookingDate: string | null;
        readonly isPending: boolean;
      } | null;
      readonly payment: {
        readonly __typename: 'PaymentInfo';
        readonly paymentFid: string;
        readonly status: Types.PaymentStatus;
        readonly kid: string | null;
        readonly message: string | null;
        readonly debtorAccount: string;
        readonly creditorAccount: string;
        readonly isTaxPayment: boolean;
        readonly external: boolean;
        readonly fee: string | null;
        readonly createdBy: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
        readonly signedBy: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
        readonly accountingSystemInformation: {
          readonly __typename: 'AccountingSystemPaymentInformation';
          readonly systemName: string;
          readonly ledgerAccount: number | null;
          readonly externalURL: string | null;
        } | null;
      } | null;
      readonly merchant: {
        readonly __typename: 'Merchant';
        readonly fid: string;
        readonly name: string;
      } | null;
      readonly receipts: ReadonlyArray<{
        readonly __typename: 'Receipt';
        readonly fid: string;
        readonly mime: string;
        readonly uploadedAt: string;
        readonly userData: string | null;
        readonly isInvoice: boolean;
        readonly receiptLooksValid: boolean;
        readonly images: {
          readonly __typename: 'ReceiptImages';
          readonly color: string;
          readonly originalUrl: string;
          readonly croppedUrl: string | null;
          readonly thumbnail128Url: string | null;
          readonly thumbnail256Url: string | null;
          readonly thumbnail512Url: string | null;
        };
      }>;
      readonly note: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly purpose: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly participants: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly receiptNotNeeded: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly receiptLost: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly requirements: {
        readonly __typename: 'EventRequirements';
        readonly metRequirementCount: number;
        readonly totalRequirementCount: number;
        readonly allRequirementsMet: boolean;
        readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly requirementsOverridden: {
          readonly __typename: 'RequirementsOverriddenInfo';
          readonly overridden: boolean;
          readonly accountingSystem: string | null;
        };
      };
      readonly ledgerCategoryInfo: {
        readonly __typename: 'LedgerCategoryInfo';
        readonly kind: Types.LedgerCategoryInfoKind;
        readonly category: {
          readonly __typename: 'LedgerCategoryItem';
          readonly fid: string;
          readonly title: string;
          readonly subtitle: string | null;
          readonly icon: Types.LedgerCategoryIcon;
          readonly synonyms: ReadonlyArray<string>;
          readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
        } | null;
        readonly guesses: ReadonlyArray<{
          readonly __typename: 'LedgerCategoryItem';
          readonly fid: string;
        }>;
      };
    };
    readonly addressBookContact: {
      readonly __typename: 'AddressBookContact';
      readonly fid: string;
      readonly accountNumber: string;
      readonly name: string;
      readonly streetAddress: string;
      readonly postalCode: string;
      readonly postalPlace: string;
      readonly country: string;
      readonly used: number;
      readonly lastTransactionDate: string;
      readonly lastCurrencyCode: string | null;
    } | null;
    readonly signedBy: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
    readonly accountingSystemInformation: {
      readonly __typename: 'AccountingSystemPaymentInformation';
      readonly systemName: string;
      readonly registeredBy: string | null;
      readonly ledgerAccount: number | null;
    } | null;
  }>;
  readonly accountingSystemInformation: {
    readonly __typename: 'AccountingSystemPaymentInformation';
    readonly systemName: string;
    readonly registeredBy: string | null;
  } | null;
  readonly debtorAccount: {
    readonly __typename: 'Account';
    readonly accountNumber: string;
    readonly name: string;
  };
};

export type GetPaymentsQueryVariables = Types.Exact<{
  statusList: ReadonlyArray<Types.PaymentStatus> | Types.PaymentStatus;
  bulkStatusList:
    | ReadonlyArray<Types.SalaryPaymentStatus>
    | Types.SalaryPaymentStatus;
  poll: Types.Scalars['Boolean'];
}>;

export type GetPaymentsQuery = {
  readonly __typename: 'Query';
  readonly paymentsByStatus: ReadonlyArray<{
    readonly __typename: 'PaymentInfo';
    readonly paymentFid: string;
    readonly createdAt: string;
    readonly creditorName: string;
    readonly creditorAccount: string;
    readonly creditorEarmarkFid: string | null;
    readonly formattedCreditorAccount: string;
    readonly confirmed: boolean;
    readonly formattedDebtorAccount: string;
    readonly debtorAccount: string;
    readonly debtorAccountName: string | null;
    readonly debtorEarmarkFid: string | null;
    readonly amount: string;
    readonly fee: string | null;
    readonly currencyCode: string;
    readonly executionDate: string;
    readonly kid: string | null;
    readonly message: string | null;
    readonly status: Types.PaymentStatus;
    readonly canBeDeleted: boolean;
    readonly external: boolean;
    readonly immutable: boolean;
    readonly isFolioInvoice: boolean;
    readonly canBeBatchApproved: boolean;
    readonly estimatedNokAmount: {
      readonly __typename: 'AmountInfo';
      readonly asNumber: number;
    } | null;
    readonly createdBy: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
    readonly event: {
      readonly __typename: 'Event';
      readonly fid: string;
      readonly dateTime: string;
      readonly movementType: Types.MovementType;
      readonly title: string;
      readonly description: string;
      readonly subtitle: string | null;
      readonly infoLine: string | null;
      readonly icon: string | null;
      readonly bulkPaymentFid: string | null;
      readonly currencyAmount: string | null;
      readonly currencyCode: string | null;
      readonly amount: string | null;
      readonly physicalTerminal: boolean;
      readonly isInvoice: boolean;
      readonly isOwnCardEvent: boolean;
      readonly completed: boolean;
      readonly isEditable: boolean;
      readonly card: {
        readonly __typename: 'Card';
        readonly fid: string;
        readonly name: string | null;
      } | null;
      readonly account: {
        readonly __typename: 'Account';
        readonly accountNumber: string;
        readonly name: string;
      } | null;
      readonly transaction: {
        readonly __typename: 'EventTransaction';
        readonly fid: string;
        readonly remittanceInformation: string | null;
        readonly debtorAccountNumber: string | null;
        readonly creditorAccountNumber: string | null;
        readonly kid: string | null;
        readonly bookingDate: string | null;
        readonly isPending: boolean;
      } | null;
      readonly payment: {
        readonly __typename: 'PaymentInfo';
        readonly paymentFid: string;
        readonly status: Types.PaymentStatus;
        readonly kid: string | null;
        readonly message: string | null;
        readonly debtorAccount: string;
        readonly creditorAccount: string;
        readonly isTaxPayment: boolean;
        readonly external: boolean;
        readonly fee: string | null;
        readonly createdBy: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
        readonly signedBy: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
        readonly accountingSystemInformation: {
          readonly __typename: 'AccountingSystemPaymentInformation';
          readonly systemName: string;
          readonly ledgerAccount: number | null;
          readonly externalURL: string | null;
        } | null;
      } | null;
      readonly merchant: {
        readonly __typename: 'Merchant';
        readonly fid: string;
        readonly name: string;
      } | null;
      readonly receipts: ReadonlyArray<{
        readonly __typename: 'Receipt';
        readonly fid: string;
        readonly mime: string;
        readonly uploadedAt: string;
        readonly userData: string | null;
        readonly isInvoice: boolean;
        readonly receiptLooksValid: boolean;
        readonly images: {
          readonly __typename: 'ReceiptImages';
          readonly color: string;
          readonly originalUrl: string;
          readonly croppedUrl: string | null;
          readonly thumbnail128Url: string | null;
          readonly thumbnail256Url: string | null;
          readonly thumbnail512Url: string | null;
        };
      }>;
      readonly note: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly purpose: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly participants: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly receiptNotNeeded: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly receiptLost: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly requirements: {
        readonly __typename: 'EventRequirements';
        readonly metRequirementCount: number;
        readonly totalRequirementCount: number;
        readonly allRequirementsMet: boolean;
        readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly requirementsOverridden: {
          readonly __typename: 'RequirementsOverriddenInfo';
          readonly overridden: boolean;
          readonly accountingSystem: string | null;
        };
      };
      readonly ledgerCategoryInfo: {
        readonly __typename: 'LedgerCategoryInfo';
        readonly kind: Types.LedgerCategoryInfoKind;
        readonly category: {
          readonly __typename: 'LedgerCategoryItem';
          readonly fid: string;
          readonly title: string;
          readonly subtitle: string | null;
          readonly icon: Types.LedgerCategoryIcon;
          readonly synonyms: ReadonlyArray<string>;
          readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
        } | null;
        readonly guesses: ReadonlyArray<{
          readonly __typename: 'LedgerCategoryItem';
          readonly fid: string;
        }>;
      };
    };
    readonly addressBookContact: {
      readonly __typename: 'AddressBookContact';
      readonly fid: string;
      readonly accountNumber: string;
      readonly name: string;
      readonly streetAddress: string;
      readonly postalCode: string;
      readonly postalPlace: string;
      readonly country: string;
      readonly used: number;
      readonly lastTransactionDate: string;
      readonly lastCurrencyCode: string | null;
    } | null;
    readonly signedBy: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
    readonly accountingSystemInformation: {
      readonly __typename: 'AccountingSystemPaymentInformation';
      readonly systemName: string;
      readonly registeredBy: string | null;
      readonly ledgerAccount: number | null;
    } | null;
  }>;
  readonly salaryPayments: ReadonlyArray<{
    readonly __typename: 'SalaryPayment';
    readonly fid: string;
    readonly amount: string;
    readonly executionDate: string;
    readonly bulkStatus: Types.SalaryPaymentStatus;
    readonly status: Types.PaymentStatus;
    readonly externalId: string | null;
    readonly payments: ReadonlyArray<{
      readonly __typename: 'PaymentInfo';
      readonly paymentFid: string;
      readonly createdAt: string;
      readonly creditorName: string;
      readonly creditorAccount: string;
      readonly creditorEarmarkFid: string | null;
      readonly formattedCreditorAccount: string;
      readonly confirmed: boolean;
      readonly formattedDebtorAccount: string;
      readonly debtorAccount: string;
      readonly debtorAccountName: string | null;
      readonly debtorEarmarkFid: string | null;
      readonly amount: string;
      readonly fee: string | null;
      readonly currencyCode: string;
      readonly executionDate: string;
      readonly kid: string | null;
      readonly message: string | null;
      readonly status: Types.PaymentStatus;
      readonly canBeDeleted: boolean;
      readonly external: boolean;
      readonly immutable: boolean;
      readonly isFolioInvoice: boolean;
      readonly canBeBatchApproved: boolean;
      readonly estimatedNokAmount: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
      readonly createdBy: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
      readonly event: {
        readonly __typename: 'Event';
        readonly fid: string;
        readonly dateTime: string;
        readonly movementType: Types.MovementType;
        readonly title: string;
        readonly description: string;
        readonly subtitle: string | null;
        readonly infoLine: string | null;
        readonly icon: string | null;
        readonly bulkPaymentFid: string | null;
        readonly currencyAmount: string | null;
        readonly currencyCode: string | null;
        readonly amount: string | null;
        readonly physicalTerminal: boolean;
        readonly isInvoice: boolean;
        readonly isOwnCardEvent: boolean;
        readonly completed: boolean;
        readonly isEditable: boolean;
        readonly card: {
          readonly __typename: 'Card';
          readonly fid: string;
          readonly name: string | null;
        } | null;
        readonly account: {
          readonly __typename: 'Account';
          readonly accountNumber: string;
          readonly name: string;
        } | null;
        readonly transaction: {
          readonly __typename: 'EventTransaction';
          readonly fid: string;
          readonly remittanceInformation: string | null;
          readonly debtorAccountNumber: string | null;
          readonly creditorAccountNumber: string | null;
          readonly kid: string | null;
          readonly bookingDate: string | null;
          readonly isPending: boolean;
        } | null;
        readonly payment: {
          readonly __typename: 'PaymentInfo';
          readonly paymentFid: string;
          readonly status: Types.PaymentStatus;
          readonly kid: string | null;
          readonly message: string | null;
          readonly debtorAccount: string;
          readonly creditorAccount: string;
          readonly isTaxPayment: boolean;
          readonly external: boolean;
          readonly fee: string | null;
          readonly createdBy: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
          readonly signedBy: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
          readonly accountingSystemInformation: {
            readonly __typename: 'AccountingSystemPaymentInformation';
            readonly systemName: string;
            readonly ledgerAccount: number | null;
            readonly externalURL: string | null;
          } | null;
        } | null;
        readonly merchant: {
          readonly __typename: 'Merchant';
          readonly fid: string;
          readonly name: string;
        } | null;
        readonly receipts: ReadonlyArray<{
          readonly __typename: 'Receipt';
          readonly fid: string;
          readonly mime: string;
          readonly uploadedAt: string;
          readonly userData: string | null;
          readonly isInvoice: boolean;
          readonly receiptLooksValid: boolean;
          readonly images: {
            readonly __typename: 'ReceiptImages';
            readonly color: string;
            readonly originalUrl: string;
            readonly croppedUrl: string | null;
            readonly thumbnail128Url: string | null;
            readonly thumbnail256Url: string | null;
            readonly thumbnail512Url: string | null;
          };
        }>;
        readonly note: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly purpose: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly participants: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly receiptNotNeeded: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly receiptLost: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly requirements: {
          readonly __typename: 'EventRequirements';
          readonly metRequirementCount: number;
          readonly totalRequirementCount: number;
          readonly allRequirementsMet: boolean;
          readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
          readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
          readonly requirementsOverridden: {
            readonly __typename: 'RequirementsOverriddenInfo';
            readonly overridden: boolean;
            readonly accountingSystem: string | null;
          };
        };
        readonly ledgerCategoryInfo: {
          readonly __typename: 'LedgerCategoryInfo';
          readonly kind: Types.LedgerCategoryInfoKind;
          readonly category: {
            readonly __typename: 'LedgerCategoryItem';
            readonly fid: string;
            readonly title: string;
            readonly subtitle: string | null;
            readonly icon: Types.LedgerCategoryIcon;
            readonly synonyms: ReadonlyArray<string>;
            readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
          } | null;
          readonly guesses: ReadonlyArray<{
            readonly __typename: 'LedgerCategoryItem';
            readonly fid: string;
          }>;
        };
      };
      readonly addressBookContact: {
        readonly __typename: 'AddressBookContact';
        readonly fid: string;
        readonly accountNumber: string;
        readonly name: string;
        readonly streetAddress: string;
        readonly postalCode: string;
        readonly postalPlace: string;
        readonly country: string;
        readonly used: number;
        readonly lastTransactionDate: string;
        readonly lastCurrencyCode: string | null;
      } | null;
      readonly signedBy: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
      readonly accountingSystemInformation: {
        readonly __typename: 'AccountingSystemPaymentInformation';
        readonly systemName: string;
        readonly registeredBy: string | null;
        readonly ledgerAccount: number | null;
      } | null;
    }>;
    readonly accountingSystemInformation: {
      readonly __typename: 'AccountingSystemPaymentInformation';
      readonly systemName: string;
      readonly registeredBy: string | null;
    } | null;
    readonly debtorAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly name: string;
    };
  }>;
};

export type GetAddressBookQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetAddressBookQuery = {
  readonly __typename: 'Query';
  readonly organization: {
    readonly __typename: 'Organization';
    readonly orgNum: string;
    readonly addressBook: ReadonlyArray<{
      readonly __typename: 'AddressBookContact';
      readonly fid: string;
      readonly accountNumber: string;
      readonly name: string;
      readonly streetAddress: string;
      readonly postalCode: string;
      readonly postalPlace: string;
      readonly country: string;
      readonly used: number;
      readonly lastTransactionDate: string;
      readonly lastCurrencyCode: string | null;
    }>;
  };
};

export type DeletePaymentMutationVariables = Types.Exact<{
  paymentFid: Types.Scalars['ID'];
}>;

export type DeletePaymentMutation = {
  readonly __typename: 'Mutation';
  readonly deletePayment: {
    readonly __typename: 'PaymentInfo';
    readonly paymentFid: string;
    readonly createdAt: string;
    readonly creditorName: string;
    readonly creditorAccount: string;
    readonly creditorEarmarkFid: string | null;
    readonly formattedCreditorAccount: string;
    readonly confirmed: boolean;
    readonly formattedDebtorAccount: string;
    readonly debtorAccount: string;
    readonly debtorAccountName: string | null;
    readonly debtorEarmarkFid: string | null;
    readonly amount: string;
    readonly fee: string | null;
    readonly currencyCode: string;
    readonly executionDate: string;
    readonly kid: string | null;
    readonly message: string | null;
    readonly status: Types.PaymentStatus;
    readonly canBeDeleted: boolean;
    readonly external: boolean;
    readonly immutable: boolean;
    readonly isFolioInvoice: boolean;
    readonly canBeBatchApproved: boolean;
    readonly estimatedNokAmount: {
      readonly __typename: 'AmountInfo';
      readonly asNumber: number;
    } | null;
    readonly createdBy: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
    readonly event: {
      readonly __typename: 'Event';
      readonly fid: string;
      readonly dateTime: string;
      readonly movementType: Types.MovementType;
      readonly title: string;
      readonly description: string;
      readonly subtitle: string | null;
      readonly infoLine: string | null;
      readonly icon: string | null;
      readonly bulkPaymentFid: string | null;
      readonly currencyAmount: string | null;
      readonly currencyCode: string | null;
      readonly amount: string | null;
      readonly physicalTerminal: boolean;
      readonly isInvoice: boolean;
      readonly isOwnCardEvent: boolean;
      readonly completed: boolean;
      readonly isEditable: boolean;
      readonly card: {
        readonly __typename: 'Card';
        readonly fid: string;
        readonly name: string | null;
      } | null;
      readonly account: {
        readonly __typename: 'Account';
        readonly accountNumber: string;
        readonly name: string;
      } | null;
      readonly transaction: {
        readonly __typename: 'EventTransaction';
        readonly fid: string;
        readonly remittanceInformation: string | null;
        readonly debtorAccountNumber: string | null;
        readonly creditorAccountNumber: string | null;
        readonly kid: string | null;
        readonly bookingDate: string | null;
        readonly isPending: boolean;
      } | null;
      readonly payment: {
        readonly __typename: 'PaymentInfo';
        readonly paymentFid: string;
        readonly status: Types.PaymentStatus;
        readonly kid: string | null;
        readonly message: string | null;
        readonly debtorAccount: string;
        readonly creditorAccount: string;
        readonly isTaxPayment: boolean;
        readonly external: boolean;
        readonly fee: string | null;
        readonly createdBy: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
        readonly signedBy: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
        readonly accountingSystemInformation: {
          readonly __typename: 'AccountingSystemPaymentInformation';
          readonly systemName: string;
          readonly ledgerAccount: number | null;
          readonly externalURL: string | null;
        } | null;
      } | null;
      readonly merchant: {
        readonly __typename: 'Merchant';
        readonly fid: string;
        readonly name: string;
      } | null;
      readonly receipts: ReadonlyArray<{
        readonly __typename: 'Receipt';
        readonly fid: string;
        readonly mime: string;
        readonly uploadedAt: string;
        readonly userData: string | null;
        readonly isInvoice: boolean;
        readonly receiptLooksValid: boolean;
        readonly images: {
          readonly __typename: 'ReceiptImages';
          readonly color: string;
          readonly originalUrl: string;
          readonly croppedUrl: string | null;
          readonly thumbnail128Url: string | null;
          readonly thumbnail256Url: string | null;
          readonly thumbnail512Url: string | null;
        };
      }>;
      readonly note: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly purpose: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly participants: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly receiptNotNeeded: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly receiptLost: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly requirements: {
        readonly __typename: 'EventRequirements';
        readonly metRequirementCount: number;
        readonly totalRequirementCount: number;
        readonly allRequirementsMet: boolean;
        readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly requirementsOverridden: {
          readonly __typename: 'RequirementsOverriddenInfo';
          readonly overridden: boolean;
          readonly accountingSystem: string | null;
        };
      };
      readonly ledgerCategoryInfo: {
        readonly __typename: 'LedgerCategoryInfo';
        readonly kind: Types.LedgerCategoryInfoKind;
        readonly category: {
          readonly __typename: 'LedgerCategoryItem';
          readonly fid: string;
          readonly title: string;
          readonly subtitle: string | null;
          readonly icon: Types.LedgerCategoryIcon;
          readonly synonyms: ReadonlyArray<string>;
          readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
        } | null;
        readonly guesses: ReadonlyArray<{
          readonly __typename: 'LedgerCategoryItem';
          readonly fid: string;
        }>;
      };
    };
    readonly addressBookContact: {
      readonly __typename: 'AddressBookContact';
      readonly fid: string;
      readonly accountNumber: string;
      readonly name: string;
      readonly streetAddress: string;
      readonly postalCode: string;
      readonly postalPlace: string;
      readonly country: string;
      readonly used: number;
      readonly lastTransactionDate: string;
      readonly lastCurrencyCode: string | null;
    } | null;
    readonly signedBy: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
    readonly accountingSystemInformation: {
      readonly __typename: 'AccountingSystemPaymentInformation';
      readonly systemName: string;
      readonly registeredBy: string | null;
      readonly ledgerAccount: number | null;
    } | null;
  };
};

export type UnapprovePaymentMutationVariables = Types.Exact<{
  paymentFid: Types.Scalars['ID'];
}>;

export type UnapprovePaymentMutation = {
  readonly __typename: 'Mutation';
  readonly unapprovePayment: {
    readonly __typename: 'PaymentInfo';
    readonly paymentFid: string;
    readonly createdAt: string;
    readonly creditorName: string;
    readonly creditorAccount: string;
    readonly creditorEarmarkFid: string | null;
    readonly formattedCreditorAccount: string;
    readonly confirmed: boolean;
    readonly formattedDebtorAccount: string;
    readonly debtorAccount: string;
    readonly debtorAccountName: string | null;
    readonly debtorEarmarkFid: string | null;
    readonly amount: string;
    readonly fee: string | null;
    readonly currencyCode: string;
    readonly executionDate: string;
    readonly kid: string | null;
    readonly message: string | null;
    readonly status: Types.PaymentStatus;
    readonly canBeDeleted: boolean;
    readonly external: boolean;
    readonly immutable: boolean;
    readonly isFolioInvoice: boolean;
    readonly canBeBatchApproved: boolean;
    readonly estimatedNokAmount: {
      readonly __typename: 'AmountInfo';
      readonly asNumber: number;
    } | null;
    readonly createdBy: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
    readonly event: {
      readonly __typename: 'Event';
      readonly fid: string;
      readonly dateTime: string;
      readonly movementType: Types.MovementType;
      readonly title: string;
      readonly description: string;
      readonly subtitle: string | null;
      readonly infoLine: string | null;
      readonly icon: string | null;
      readonly bulkPaymentFid: string | null;
      readonly currencyAmount: string | null;
      readonly currencyCode: string | null;
      readonly amount: string | null;
      readonly physicalTerminal: boolean;
      readonly isInvoice: boolean;
      readonly isOwnCardEvent: boolean;
      readonly completed: boolean;
      readonly isEditable: boolean;
      readonly card: {
        readonly __typename: 'Card';
        readonly fid: string;
        readonly name: string | null;
      } | null;
      readonly account: {
        readonly __typename: 'Account';
        readonly accountNumber: string;
        readonly name: string;
      } | null;
      readonly transaction: {
        readonly __typename: 'EventTransaction';
        readonly fid: string;
        readonly remittanceInformation: string | null;
        readonly debtorAccountNumber: string | null;
        readonly creditorAccountNumber: string | null;
        readonly kid: string | null;
        readonly bookingDate: string | null;
        readonly isPending: boolean;
      } | null;
      readonly payment: {
        readonly __typename: 'PaymentInfo';
        readonly paymentFid: string;
        readonly status: Types.PaymentStatus;
        readonly kid: string | null;
        readonly message: string | null;
        readonly debtorAccount: string;
        readonly creditorAccount: string;
        readonly isTaxPayment: boolean;
        readonly external: boolean;
        readonly fee: string | null;
        readonly createdBy: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
        readonly signedBy: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
        readonly accountingSystemInformation: {
          readonly __typename: 'AccountingSystemPaymentInformation';
          readonly systemName: string;
          readonly ledgerAccount: number | null;
          readonly externalURL: string | null;
        } | null;
      } | null;
      readonly merchant: {
        readonly __typename: 'Merchant';
        readonly fid: string;
        readonly name: string;
      } | null;
      readonly receipts: ReadonlyArray<{
        readonly __typename: 'Receipt';
        readonly fid: string;
        readonly mime: string;
        readonly uploadedAt: string;
        readonly userData: string | null;
        readonly isInvoice: boolean;
        readonly receiptLooksValid: boolean;
        readonly images: {
          readonly __typename: 'ReceiptImages';
          readonly color: string;
          readonly originalUrl: string;
          readonly croppedUrl: string | null;
          readonly thumbnail128Url: string | null;
          readonly thumbnail256Url: string | null;
          readonly thumbnail512Url: string | null;
        };
      }>;
      readonly note: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly purpose: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly participants: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly receiptNotNeeded: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly receiptLost: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly requirements: {
        readonly __typename: 'EventRequirements';
        readonly metRequirementCount: number;
        readonly totalRequirementCount: number;
        readonly allRequirementsMet: boolean;
        readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly requirementsOverridden: {
          readonly __typename: 'RequirementsOverriddenInfo';
          readonly overridden: boolean;
          readonly accountingSystem: string | null;
        };
      };
      readonly ledgerCategoryInfo: {
        readonly __typename: 'LedgerCategoryInfo';
        readonly kind: Types.LedgerCategoryInfoKind;
        readonly category: {
          readonly __typename: 'LedgerCategoryItem';
          readonly fid: string;
          readonly title: string;
          readonly subtitle: string | null;
          readonly icon: Types.LedgerCategoryIcon;
          readonly synonyms: ReadonlyArray<string>;
          readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
        } | null;
        readonly guesses: ReadonlyArray<{
          readonly __typename: 'LedgerCategoryItem';
          readonly fid: string;
        }>;
      };
    };
    readonly addressBookContact: {
      readonly __typename: 'AddressBookContact';
      readonly fid: string;
      readonly accountNumber: string;
      readonly name: string;
      readonly streetAddress: string;
      readonly postalCode: string;
      readonly postalPlace: string;
      readonly country: string;
      readonly used: number;
      readonly lastTransactionDate: string;
      readonly lastCurrencyCode: string | null;
    } | null;
    readonly signedBy: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
    readonly accountingSystemInformation: {
      readonly __typename: 'AccountingSystemPaymentInformation';
      readonly systemName: string;
      readonly registeredBy: string | null;
      readonly ledgerAccount: number | null;
    } | null;
  };
};

export type CreatePaymentMutationVariables = Types.Exact<{
  createPaymentInput: Types.CreatePaymentInput;
}>;

export type CreatePaymentMutation = {
  readonly __typename: 'Mutation';
  readonly createPayment: {
    readonly __typename: 'CreatePaymentReply';
    readonly bookkeepingError: boolean;
    readonly payment: {
      readonly __typename: 'PaymentInfo';
      readonly paymentFid: string;
      readonly addressBookContact: {
        readonly __typename: 'AddressBookContact';
        readonly fid: string;
        readonly accountNumber: string;
        readonly name: string;
        readonly streetAddress: string;
        readonly postalCode: string;
        readonly postalPlace: string;
        readonly country: string;
        readonly used: number;
        readonly lastTransactionDate: string;
        readonly lastCurrencyCode: string | null;
      } | null;
    };
  };
};

export type CreateCrossborderPaymentMutationVariables = Types.Exact<{
  input: Types.CreateCrossborderPaymentInput;
}>;

export type CreateCrossborderPaymentMutation = {
  readonly __typename: 'Mutation';
  readonly createCrossborderPayment: {
    readonly __typename: 'CreateCrossborderPaymentReply';
    readonly bookkeepingError: boolean;
    readonly payment: {
      readonly __typename: 'PaymentInfo';
      readonly paymentFid: string;
      readonly addressBookContact: {
        readonly __typename: 'AddressBookContact';
        readonly fid: string;
        readonly accountNumber: string;
        readonly name: string;
        readonly streetAddress: string;
        readonly postalCode: string;
        readonly postalPlace: string;
        readonly country: string;
        readonly used: number;
        readonly lastTransactionDate: string;
        readonly lastCurrencyCode: string | null;
      } | null;
    };
  };
};

export type InitiatePaymentsMutationVariables = Types.Exact<{
  paymentsInput: Types.InitiatePaymentsInput;
}>;

export type InitiatePaymentsMutation = {
  readonly __typename: 'Mutation';
  readonly initiatePayments: {
    readonly __typename: 'InitiatePaymentsReply';
    readonly authUrl: string | null;
  };
};

export type AddAmlRecordMutationVariables = Types.Exact<{
  input: Types.AddCrossborderPaymentAmlRecordInput;
}>;

export type AddAmlRecordMutation = {
  readonly __typename: 'Mutation';
  readonly addCrossborderPaymentAmlRecord: {
    readonly __typename: 'Organization';
    readonly orgNum: string;
    readonly crossborderPaymentAmlRecords: ReadonlyArray<{
      readonly __typename: 'CrossborderPaymentAmlRecord';
      readonly countryCode: string;
    }>;
  };
};

export type GetReceiptsForPaymentQueryVariables = Types.Exact<{
  receiptFids: ReadonlyArray<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;

export type GetReceiptsForPaymentQuery = {
  readonly __typename: 'Query';
  readonly receipts: ReadonlyArray<{
    readonly __typename: 'Receipt';
    readonly fid: string;
    readonly mime: string;
    readonly uploadedAt: string;
    readonly userData: string | null;
    readonly isInvoice: boolean;
    readonly receiptLooksValid: boolean;
    readonly images: {
      readonly __typename: 'ReceiptImages';
      readonly color: string;
      readonly originalUrl: string;
      readonly croppedUrl: string | null;
      readonly thumbnail128Url: string | null;
      readonly thumbnail256Url: string | null;
      readonly thumbnail512Url: string | null;
    };
  }>;
};

export type PaymentDetailsQueryVariables = Types.Exact<{
  fid: Types.Scalars['ID'];
}>;

export type PaymentDetailsQuery = {
  readonly __typename: 'Query';
  readonly payment: {
    readonly __typename: 'PaymentInfo';
    readonly paymentFid: string;
    readonly createdAt: string;
    readonly creditorName: string;
    readonly creditorAccount: string;
    readonly creditorEarmarkFid: string | null;
    readonly formattedCreditorAccount: string;
    readonly confirmed: boolean;
    readonly formattedDebtorAccount: string;
    readonly debtorAccount: string;
    readonly debtorAccountName: string | null;
    readonly debtorEarmarkFid: string | null;
    readonly amount: string;
    readonly fee: string | null;
    readonly currencyCode: string;
    readonly executionDate: string;
    readonly kid: string | null;
    readonly message: string | null;
    readonly status: Types.PaymentStatus;
    readonly canBeDeleted: boolean;
    readonly external: boolean;
    readonly immutable: boolean;
    readonly isFolioInvoice: boolean;
    readonly canBeBatchApproved: boolean;
    readonly estimatedNokAmount: {
      readonly __typename: 'AmountInfo';
      readonly asNumber: number;
    } | null;
    readonly createdBy: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
    readonly event: {
      readonly __typename: 'Event';
      readonly fid: string;
      readonly dateTime: string;
      readonly movementType: Types.MovementType;
      readonly title: string;
      readonly description: string;
      readonly subtitle: string | null;
      readonly infoLine: string | null;
      readonly icon: string | null;
      readonly bulkPaymentFid: string | null;
      readonly currencyAmount: string | null;
      readonly currencyCode: string | null;
      readonly amount: string | null;
      readonly physicalTerminal: boolean;
      readonly isInvoice: boolean;
      readonly isOwnCardEvent: boolean;
      readonly completed: boolean;
      readonly isEditable: boolean;
      readonly card: {
        readonly __typename: 'Card';
        readonly fid: string;
        readonly name: string | null;
      } | null;
      readonly account: {
        readonly __typename: 'Account';
        readonly accountNumber: string;
        readonly name: string;
      } | null;
      readonly transaction: {
        readonly __typename: 'EventTransaction';
        readonly fid: string;
        readonly remittanceInformation: string | null;
        readonly debtorAccountNumber: string | null;
        readonly creditorAccountNumber: string | null;
        readonly kid: string | null;
        readonly bookingDate: string | null;
        readonly isPending: boolean;
      } | null;
      readonly payment: {
        readonly __typename: 'PaymentInfo';
        readonly paymentFid: string;
        readonly status: Types.PaymentStatus;
        readonly kid: string | null;
        readonly message: string | null;
        readonly debtorAccount: string;
        readonly creditorAccount: string;
        readonly isTaxPayment: boolean;
        readonly external: boolean;
        readonly fee: string | null;
        readonly createdBy: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
        readonly signedBy: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
        readonly accountingSystemInformation: {
          readonly __typename: 'AccountingSystemPaymentInformation';
          readonly systemName: string;
          readonly ledgerAccount: number | null;
          readonly externalURL: string | null;
        } | null;
      } | null;
      readonly merchant: {
        readonly __typename: 'Merchant';
        readonly fid: string;
        readonly name: string;
      } | null;
      readonly receipts: ReadonlyArray<{
        readonly __typename: 'Receipt';
        readonly fid: string;
        readonly mime: string;
        readonly uploadedAt: string;
        readonly userData: string | null;
        readonly isInvoice: boolean;
        readonly receiptLooksValid: boolean;
        readonly images: {
          readonly __typename: 'ReceiptImages';
          readonly color: string;
          readonly originalUrl: string;
          readonly croppedUrl: string | null;
          readonly thumbnail128Url: string | null;
          readonly thumbnail256Url: string | null;
          readonly thumbnail512Url: string | null;
        };
      }>;
      readonly note: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly purpose: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly participants: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly receiptNotNeeded: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly receiptLost: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly requirements: {
        readonly __typename: 'EventRequirements';
        readonly metRequirementCount: number;
        readonly totalRequirementCount: number;
        readonly allRequirementsMet: boolean;
        readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly requirementsOverridden: {
          readonly __typename: 'RequirementsOverriddenInfo';
          readonly overridden: boolean;
          readonly accountingSystem: string | null;
        };
      };
      readonly ledgerCategoryInfo: {
        readonly __typename: 'LedgerCategoryInfo';
        readonly kind: Types.LedgerCategoryInfoKind;
        readonly category: {
          readonly __typename: 'LedgerCategoryItem';
          readonly fid: string;
          readonly title: string;
          readonly subtitle: string | null;
          readonly icon: Types.LedgerCategoryIcon;
          readonly synonyms: ReadonlyArray<string>;
          readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
        } | null;
        readonly guesses: ReadonlyArray<{
          readonly __typename: 'LedgerCategoryItem';
          readonly fid: string;
        }>;
      };
    };
    readonly addressBookContact: {
      readonly __typename: 'AddressBookContact';
      readonly fid: string;
      readonly accountNumber: string;
      readonly name: string;
      readonly streetAddress: string;
      readonly postalCode: string;
      readonly postalPlace: string;
      readonly country: string;
      readonly used: number;
      readonly lastTransactionDate: string;
      readonly lastCurrencyCode: string | null;
    } | null;
    readonly signedBy: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
    readonly accountingSystemInformation: {
      readonly __typename: 'AccountingSystemPaymentInformation';
      readonly systemName: string;
      readonly registeredBy: string | null;
      readonly ledgerAccount: number | null;
    } | null;
  };
};

export type SalaryPaymentDetailsQueryVariables = Types.Exact<{
  fid: Types.Scalars['UUID'];
}>;

export type SalaryPaymentDetailsQuery = {
  readonly __typename: 'Query';
  readonly salaryPayment: {
    readonly __typename: 'SalaryPayment';
    readonly fid: string;
    readonly amount: string;
    readonly executionDate: string;
    readonly bulkStatus: Types.SalaryPaymentStatus;
    readonly status: Types.PaymentStatus;
    readonly externalId: string | null;
    readonly payments: ReadonlyArray<{
      readonly __typename: 'PaymentInfo';
      readonly paymentFid: string;
      readonly createdAt: string;
      readonly creditorName: string;
      readonly creditorAccount: string;
      readonly creditorEarmarkFid: string | null;
      readonly formattedCreditorAccount: string;
      readonly confirmed: boolean;
      readonly formattedDebtorAccount: string;
      readonly debtorAccount: string;
      readonly debtorAccountName: string | null;
      readonly debtorEarmarkFid: string | null;
      readonly amount: string;
      readonly fee: string | null;
      readonly currencyCode: string;
      readonly executionDate: string;
      readonly kid: string | null;
      readonly message: string | null;
      readonly status: Types.PaymentStatus;
      readonly canBeDeleted: boolean;
      readonly external: boolean;
      readonly immutable: boolean;
      readonly isFolioInvoice: boolean;
      readonly canBeBatchApproved: boolean;
      readonly estimatedNokAmount: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
      readonly createdBy: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
      readonly event: {
        readonly __typename: 'Event';
        readonly fid: string;
        readonly dateTime: string;
        readonly movementType: Types.MovementType;
        readonly title: string;
        readonly description: string;
        readonly subtitle: string | null;
        readonly infoLine: string | null;
        readonly icon: string | null;
        readonly bulkPaymentFid: string | null;
        readonly currencyAmount: string | null;
        readonly currencyCode: string | null;
        readonly amount: string | null;
        readonly physicalTerminal: boolean;
        readonly isInvoice: boolean;
        readonly isOwnCardEvent: boolean;
        readonly completed: boolean;
        readonly isEditable: boolean;
        readonly card: {
          readonly __typename: 'Card';
          readonly fid: string;
          readonly name: string | null;
        } | null;
        readonly account: {
          readonly __typename: 'Account';
          readonly accountNumber: string;
          readonly name: string;
        } | null;
        readonly transaction: {
          readonly __typename: 'EventTransaction';
          readonly fid: string;
          readonly remittanceInformation: string | null;
          readonly debtorAccountNumber: string | null;
          readonly creditorAccountNumber: string | null;
          readonly kid: string | null;
          readonly bookingDate: string | null;
          readonly isPending: boolean;
        } | null;
        readonly payment: {
          readonly __typename: 'PaymentInfo';
          readonly paymentFid: string;
          readonly status: Types.PaymentStatus;
          readonly kid: string | null;
          readonly message: string | null;
          readonly debtorAccount: string;
          readonly creditorAccount: string;
          readonly isTaxPayment: boolean;
          readonly external: boolean;
          readonly fee: string | null;
          readonly createdBy: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
          readonly signedBy: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
          readonly accountingSystemInformation: {
            readonly __typename: 'AccountingSystemPaymentInformation';
            readonly systemName: string;
            readonly ledgerAccount: number | null;
            readonly externalURL: string | null;
          } | null;
        } | null;
        readonly merchant: {
          readonly __typename: 'Merchant';
          readonly fid: string;
          readonly name: string;
        } | null;
        readonly receipts: ReadonlyArray<{
          readonly __typename: 'Receipt';
          readonly fid: string;
          readonly mime: string;
          readonly uploadedAt: string;
          readonly userData: string | null;
          readonly isInvoice: boolean;
          readonly receiptLooksValid: boolean;
          readonly images: {
            readonly __typename: 'ReceiptImages';
            readonly color: string;
            readonly originalUrl: string;
            readonly croppedUrl: string | null;
            readonly thumbnail128Url: string | null;
            readonly thumbnail256Url: string | null;
            readonly thumbnail512Url: string | null;
          };
        }>;
        readonly note: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly purpose: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly participants: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly receiptNotNeeded: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly receiptLost: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly requirements: {
          readonly __typename: 'EventRequirements';
          readonly metRequirementCount: number;
          readonly totalRequirementCount: number;
          readonly allRequirementsMet: boolean;
          readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
          readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
          readonly requirementsOverridden: {
            readonly __typename: 'RequirementsOverriddenInfo';
            readonly overridden: boolean;
            readonly accountingSystem: string | null;
          };
        };
        readonly ledgerCategoryInfo: {
          readonly __typename: 'LedgerCategoryInfo';
          readonly kind: Types.LedgerCategoryInfoKind;
          readonly category: {
            readonly __typename: 'LedgerCategoryItem';
            readonly fid: string;
            readonly title: string;
            readonly subtitle: string | null;
            readonly icon: Types.LedgerCategoryIcon;
            readonly synonyms: ReadonlyArray<string>;
            readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
          } | null;
          readonly guesses: ReadonlyArray<{
            readonly __typename: 'LedgerCategoryItem';
            readonly fid: string;
          }>;
        };
      };
      readonly addressBookContact: {
        readonly __typename: 'AddressBookContact';
        readonly fid: string;
        readonly accountNumber: string;
        readonly name: string;
        readonly streetAddress: string;
        readonly postalCode: string;
        readonly postalPlace: string;
        readonly country: string;
        readonly used: number;
        readonly lastTransactionDate: string;
        readonly lastCurrencyCode: string | null;
      } | null;
      readonly signedBy: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
      readonly accountingSystemInformation: {
        readonly __typename: 'AccountingSystemPaymentInformation';
        readonly systemName: string;
        readonly registeredBy: string | null;
        readonly ledgerAccount: number | null;
      } | null;
    }>;
    readonly accountingSystemInformation: {
      readonly __typename: 'AccountingSystemPaymentInformation';
      readonly systemName: string;
      readonly registeredBy: string | null;
    } | null;
    readonly debtorAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly name: string;
    };
  };
};

export type DeleteSalaryPaymentMutationVariables = Types.Exact<{
  bulkPaymentFid: Types.Scalars['UUID'];
}>;

export type DeleteSalaryPaymentMutation = {
  readonly __typename: 'Mutation';
  readonly deleteSalaryPayment: {
    readonly __typename: 'SalaryPayment';
    readonly fid: string;
    readonly amount: string;
    readonly executionDate: string;
    readonly bulkStatus: Types.SalaryPaymentStatus;
    readonly status: Types.PaymentStatus;
    readonly externalId: string | null;
    readonly payments: ReadonlyArray<{
      readonly __typename: 'PaymentInfo';
      readonly paymentFid: string;
      readonly createdAt: string;
      readonly creditorName: string;
      readonly creditorAccount: string;
      readonly creditorEarmarkFid: string | null;
      readonly formattedCreditorAccount: string;
      readonly confirmed: boolean;
      readonly formattedDebtorAccount: string;
      readonly debtorAccount: string;
      readonly debtorAccountName: string | null;
      readonly debtorEarmarkFid: string | null;
      readonly amount: string;
      readonly fee: string | null;
      readonly currencyCode: string;
      readonly executionDate: string;
      readonly kid: string | null;
      readonly message: string | null;
      readonly status: Types.PaymentStatus;
      readonly canBeDeleted: boolean;
      readonly external: boolean;
      readonly immutable: boolean;
      readonly isFolioInvoice: boolean;
      readonly canBeBatchApproved: boolean;
      readonly estimatedNokAmount: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
      readonly createdBy: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
      readonly event: {
        readonly __typename: 'Event';
        readonly fid: string;
        readonly dateTime: string;
        readonly movementType: Types.MovementType;
        readonly title: string;
        readonly description: string;
        readonly subtitle: string | null;
        readonly infoLine: string | null;
        readonly icon: string | null;
        readonly bulkPaymentFid: string | null;
        readonly currencyAmount: string | null;
        readonly currencyCode: string | null;
        readonly amount: string | null;
        readonly physicalTerminal: boolean;
        readonly isInvoice: boolean;
        readonly isOwnCardEvent: boolean;
        readonly completed: boolean;
        readonly isEditable: boolean;
        readonly card: {
          readonly __typename: 'Card';
          readonly fid: string;
          readonly name: string | null;
        } | null;
        readonly account: {
          readonly __typename: 'Account';
          readonly accountNumber: string;
          readonly name: string;
        } | null;
        readonly transaction: {
          readonly __typename: 'EventTransaction';
          readonly fid: string;
          readonly remittanceInformation: string | null;
          readonly debtorAccountNumber: string | null;
          readonly creditorAccountNumber: string | null;
          readonly kid: string | null;
          readonly bookingDate: string | null;
          readonly isPending: boolean;
        } | null;
        readonly payment: {
          readonly __typename: 'PaymentInfo';
          readonly paymentFid: string;
          readonly status: Types.PaymentStatus;
          readonly kid: string | null;
          readonly message: string | null;
          readonly debtorAccount: string;
          readonly creditorAccount: string;
          readonly isTaxPayment: boolean;
          readonly external: boolean;
          readonly fee: string | null;
          readonly createdBy: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
          readonly signedBy: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
          readonly accountingSystemInformation: {
            readonly __typename: 'AccountingSystemPaymentInformation';
            readonly systemName: string;
            readonly ledgerAccount: number | null;
            readonly externalURL: string | null;
          } | null;
        } | null;
        readonly merchant: {
          readonly __typename: 'Merchant';
          readonly fid: string;
          readonly name: string;
        } | null;
        readonly receipts: ReadonlyArray<{
          readonly __typename: 'Receipt';
          readonly fid: string;
          readonly mime: string;
          readonly uploadedAt: string;
          readonly userData: string | null;
          readonly isInvoice: boolean;
          readonly receiptLooksValid: boolean;
          readonly images: {
            readonly __typename: 'ReceiptImages';
            readonly color: string;
            readonly originalUrl: string;
            readonly croppedUrl: string | null;
            readonly thumbnail128Url: string | null;
            readonly thumbnail256Url: string | null;
            readonly thumbnail512Url: string | null;
          };
        }>;
        readonly note: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly purpose: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly participants: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly receiptNotNeeded: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly receiptLost: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly requirements: {
          readonly __typename: 'EventRequirements';
          readonly metRequirementCount: number;
          readonly totalRequirementCount: number;
          readonly allRequirementsMet: boolean;
          readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
          readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
          readonly requirementsOverridden: {
            readonly __typename: 'RequirementsOverriddenInfo';
            readonly overridden: boolean;
            readonly accountingSystem: string | null;
          };
        };
        readonly ledgerCategoryInfo: {
          readonly __typename: 'LedgerCategoryInfo';
          readonly kind: Types.LedgerCategoryInfoKind;
          readonly category: {
            readonly __typename: 'LedgerCategoryItem';
            readonly fid: string;
            readonly title: string;
            readonly subtitle: string | null;
            readonly icon: Types.LedgerCategoryIcon;
            readonly synonyms: ReadonlyArray<string>;
            readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
          } | null;
          readonly guesses: ReadonlyArray<{
            readonly __typename: 'LedgerCategoryItem';
            readonly fid: string;
          }>;
        };
      };
      readonly addressBookContact: {
        readonly __typename: 'AddressBookContact';
        readonly fid: string;
        readonly accountNumber: string;
        readonly name: string;
        readonly streetAddress: string;
        readonly postalCode: string;
        readonly postalPlace: string;
        readonly country: string;
        readonly used: number;
        readonly lastTransactionDate: string;
        readonly lastCurrencyCode: string | null;
      } | null;
      readonly signedBy: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
      readonly accountingSystemInformation: {
        readonly __typename: 'AccountingSystemPaymentInformation';
        readonly systemName: string;
        readonly registeredBy: string | null;
        readonly ledgerAccount: number | null;
      } | null;
    }>;
    readonly accountingSystemInformation: {
      readonly __typename: 'AccountingSystemPaymentInformation';
      readonly systemName: string;
      readonly registeredBy: string | null;
    } | null;
    readonly debtorAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly name: string;
    };
  };
};

export type UnapproveSalaryPaymentMutationVariables = Types.Exact<{
  bulkPaymentFid: Types.Scalars['UUID'];
}>;

export type UnapproveSalaryPaymentMutation = {
  readonly __typename: 'Mutation';
  readonly unapproveSalaryPayment: {
    readonly __typename: 'SalaryPayment';
    readonly fid: string;
    readonly amount: string;
    readonly executionDate: string;
    readonly bulkStatus: Types.SalaryPaymentStatus;
    readonly status: Types.PaymentStatus;
    readonly externalId: string | null;
    readonly payments: ReadonlyArray<{
      readonly __typename: 'PaymentInfo';
      readonly paymentFid: string;
      readonly createdAt: string;
      readonly creditorName: string;
      readonly creditorAccount: string;
      readonly creditorEarmarkFid: string | null;
      readonly formattedCreditorAccount: string;
      readonly confirmed: boolean;
      readonly formattedDebtorAccount: string;
      readonly debtorAccount: string;
      readonly debtorAccountName: string | null;
      readonly debtorEarmarkFid: string | null;
      readonly amount: string;
      readonly fee: string | null;
      readonly currencyCode: string;
      readonly executionDate: string;
      readonly kid: string | null;
      readonly message: string | null;
      readonly status: Types.PaymentStatus;
      readonly canBeDeleted: boolean;
      readonly external: boolean;
      readonly immutable: boolean;
      readonly isFolioInvoice: boolean;
      readonly canBeBatchApproved: boolean;
      readonly estimatedNokAmount: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
      readonly createdBy: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
      readonly event: {
        readonly __typename: 'Event';
        readonly fid: string;
        readonly dateTime: string;
        readonly movementType: Types.MovementType;
        readonly title: string;
        readonly description: string;
        readonly subtitle: string | null;
        readonly infoLine: string | null;
        readonly icon: string | null;
        readonly bulkPaymentFid: string | null;
        readonly currencyAmount: string | null;
        readonly currencyCode: string | null;
        readonly amount: string | null;
        readonly physicalTerminal: boolean;
        readonly isInvoice: boolean;
        readonly isOwnCardEvent: boolean;
        readonly completed: boolean;
        readonly isEditable: boolean;
        readonly card: {
          readonly __typename: 'Card';
          readonly fid: string;
          readonly name: string | null;
        } | null;
        readonly account: {
          readonly __typename: 'Account';
          readonly accountNumber: string;
          readonly name: string;
        } | null;
        readonly transaction: {
          readonly __typename: 'EventTransaction';
          readonly fid: string;
          readonly remittanceInformation: string | null;
          readonly debtorAccountNumber: string | null;
          readonly creditorAccountNumber: string | null;
          readonly kid: string | null;
          readonly bookingDate: string | null;
          readonly isPending: boolean;
        } | null;
        readonly payment: {
          readonly __typename: 'PaymentInfo';
          readonly paymentFid: string;
          readonly status: Types.PaymentStatus;
          readonly kid: string | null;
          readonly message: string | null;
          readonly debtorAccount: string;
          readonly creditorAccount: string;
          readonly isTaxPayment: boolean;
          readonly external: boolean;
          readonly fee: string | null;
          readonly createdBy: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
          readonly signedBy: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
          readonly accountingSystemInformation: {
            readonly __typename: 'AccountingSystemPaymentInformation';
            readonly systemName: string;
            readonly ledgerAccount: number | null;
            readonly externalURL: string | null;
          } | null;
        } | null;
        readonly merchant: {
          readonly __typename: 'Merchant';
          readonly fid: string;
          readonly name: string;
        } | null;
        readonly receipts: ReadonlyArray<{
          readonly __typename: 'Receipt';
          readonly fid: string;
          readonly mime: string;
          readonly uploadedAt: string;
          readonly userData: string | null;
          readonly isInvoice: boolean;
          readonly receiptLooksValid: boolean;
          readonly images: {
            readonly __typename: 'ReceiptImages';
            readonly color: string;
            readonly originalUrl: string;
            readonly croppedUrl: string | null;
            readonly thumbnail128Url: string | null;
            readonly thumbnail256Url: string | null;
            readonly thumbnail512Url: string | null;
          };
        }>;
        readonly note: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly purpose: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly participants: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly receiptNotNeeded: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly receiptLost: {
          readonly __typename: 'Annotation';
          readonly fid: string;
          readonly dateTime: string;
          readonly text: string;
          readonly agentInfo: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
              readonly first: string | null;
            };
          } | null;
        } | null;
        readonly requirements: {
          readonly __typename: 'EventRequirements';
          readonly metRequirementCount: number;
          readonly totalRequirementCount: number;
          readonly allRequirementsMet: boolean;
          readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
          readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
          readonly requirementsOverridden: {
            readonly __typename: 'RequirementsOverriddenInfo';
            readonly overridden: boolean;
            readonly accountingSystem: string | null;
          };
        };
        readonly ledgerCategoryInfo: {
          readonly __typename: 'LedgerCategoryInfo';
          readonly kind: Types.LedgerCategoryInfoKind;
          readonly category: {
            readonly __typename: 'LedgerCategoryItem';
            readonly fid: string;
            readonly title: string;
            readonly subtitle: string | null;
            readonly icon: Types.LedgerCategoryIcon;
            readonly synonyms: ReadonlyArray<string>;
            readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
          } | null;
          readonly guesses: ReadonlyArray<{
            readonly __typename: 'LedgerCategoryItem';
            readonly fid: string;
          }>;
        };
      };
      readonly addressBookContact: {
        readonly __typename: 'AddressBookContact';
        readonly fid: string;
        readonly accountNumber: string;
        readonly name: string;
        readonly streetAddress: string;
        readonly postalCode: string;
        readonly postalPlace: string;
        readonly country: string;
        readonly used: number;
        readonly lastTransactionDate: string;
        readonly lastCurrencyCode: string | null;
      } | null;
      readonly signedBy: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      } | null;
      readonly accountingSystemInformation: {
        readonly __typename: 'AccountingSystemPaymentInformation';
        readonly systemName: string;
        readonly registeredBy: string | null;
        readonly ledgerAccount: number | null;
      } | null;
    }>;
    readonly accountingSystemInformation: {
      readonly __typename: 'AccountingSystemPaymentInformation';
      readonly systemName: string;
      readonly registeredBy: string | null;
    } | null;
    readonly debtorAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly name: string;
    };
  };
};

export type UpdatePaymentMutationVariables = Types.Exact<{
  input: Types.UpdatePaymentInput;
}>;

export type UpdatePaymentMutation = {
  readonly __typename: 'Mutation';
  readonly updatePayment: {
    readonly __typename: 'PaymentInfo';
    readonly paymentFid: string;
    readonly createdAt: string;
    readonly creditorName: string;
    readonly creditorAccount: string;
    readonly creditorEarmarkFid: string | null;
    readonly formattedCreditorAccount: string;
    readonly confirmed: boolean;
    readonly formattedDebtorAccount: string;
    readonly debtorAccount: string;
    readonly debtorAccountName: string | null;
    readonly debtorEarmarkFid: string | null;
    readonly amount: string;
    readonly fee: string | null;
    readonly currencyCode: string;
    readonly executionDate: string;
    readonly kid: string | null;
    readonly message: string | null;
    readonly status: Types.PaymentStatus;
    readonly canBeDeleted: boolean;
    readonly external: boolean;
    readonly immutable: boolean;
    readonly isFolioInvoice: boolean;
    readonly canBeBatchApproved: boolean;
    readonly estimatedNokAmount: {
      readonly __typename: 'AmountInfo';
      readonly asNumber: number;
    } | null;
    readonly createdBy: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
    readonly event: {
      readonly __typename: 'Event';
      readonly fid: string;
      readonly dateTime: string;
      readonly movementType: Types.MovementType;
      readonly title: string;
      readonly description: string;
      readonly subtitle: string | null;
      readonly infoLine: string | null;
      readonly icon: string | null;
      readonly bulkPaymentFid: string | null;
      readonly currencyAmount: string | null;
      readonly currencyCode: string | null;
      readonly amount: string | null;
      readonly physicalTerminal: boolean;
      readonly isInvoice: boolean;
      readonly isOwnCardEvent: boolean;
      readonly completed: boolean;
      readonly isEditable: boolean;
      readonly card: {
        readonly __typename: 'Card';
        readonly fid: string;
        readonly name: string | null;
      } | null;
      readonly account: {
        readonly __typename: 'Account';
        readonly accountNumber: string;
        readonly name: string;
      } | null;
      readonly transaction: {
        readonly __typename: 'EventTransaction';
        readonly fid: string;
        readonly remittanceInformation: string | null;
        readonly debtorAccountNumber: string | null;
        readonly creditorAccountNumber: string | null;
        readonly kid: string | null;
        readonly bookingDate: string | null;
        readonly isPending: boolean;
      } | null;
      readonly payment: {
        readonly __typename: 'PaymentInfo';
        readonly paymentFid: string;
        readonly status: Types.PaymentStatus;
        readonly kid: string | null;
        readonly message: string | null;
        readonly debtorAccount: string;
        readonly creditorAccount: string;
        readonly isTaxPayment: boolean;
        readonly external: boolean;
        readonly fee: string | null;
        readonly createdBy: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
        readonly signedBy: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
        readonly accountingSystemInformation: {
          readonly __typename: 'AccountingSystemPaymentInformation';
          readonly systemName: string;
          readonly ledgerAccount: number | null;
          readonly externalURL: string | null;
        } | null;
      } | null;
      readonly merchant: {
        readonly __typename: 'Merchant';
        readonly fid: string;
        readonly name: string;
      } | null;
      readonly receipts: ReadonlyArray<{
        readonly __typename: 'Receipt';
        readonly fid: string;
        readonly mime: string;
        readonly uploadedAt: string;
        readonly userData: string | null;
        readonly isInvoice: boolean;
        readonly receiptLooksValid: boolean;
        readonly images: {
          readonly __typename: 'ReceiptImages';
          readonly color: string;
          readonly originalUrl: string;
          readonly croppedUrl: string | null;
          readonly thumbnail128Url: string | null;
          readonly thumbnail256Url: string | null;
          readonly thumbnail512Url: string | null;
        };
      }>;
      readonly note: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly purpose: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly participants: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly receiptNotNeeded: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly receiptLost: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly requirements: {
        readonly __typename: 'EventRequirements';
        readonly metRequirementCount: number;
        readonly totalRequirementCount: number;
        readonly allRequirementsMet: boolean;
        readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly requirementsOverridden: {
          readonly __typename: 'RequirementsOverriddenInfo';
          readonly overridden: boolean;
          readonly accountingSystem: string | null;
        };
      };
      readonly ledgerCategoryInfo: {
        readonly __typename: 'LedgerCategoryInfo';
        readonly kind: Types.LedgerCategoryInfoKind;
        readonly category: {
          readonly __typename: 'LedgerCategoryItem';
          readonly fid: string;
          readonly title: string;
          readonly subtitle: string | null;
          readonly icon: Types.LedgerCategoryIcon;
          readonly synonyms: ReadonlyArray<string>;
          readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
        } | null;
        readonly guesses: ReadonlyArray<{
          readonly __typename: 'LedgerCategoryItem';
          readonly fid: string;
        }>;
      };
    };
    readonly addressBookContact: {
      readonly __typename: 'AddressBookContact';
      readonly fid: string;
      readonly accountNumber: string;
      readonly name: string;
      readonly streetAddress: string;
      readonly postalCode: string;
      readonly postalPlace: string;
      readonly country: string;
      readonly used: number;
      readonly lastTransactionDate: string;
      readonly lastCurrencyCode: string | null;
    } | null;
    readonly signedBy: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    } | null;
    readonly accountingSystemInformation: {
      readonly __typename: 'AccountingSystemPaymentInformation';
      readonly systemName: string;
      readonly registeredBy: string | null;
      readonly ledgerAccount: number | null;
    } | null;
  };
};

export type DeleteAddressBookContactMutationVariables = Types.Exact<{
  fid: Types.Scalars['UUID'];
}>;

export type DeleteAddressBookContactMutation = {
  readonly __typename: 'Mutation';
  readonly deleteAddressBookContact: {
    readonly __typename: 'AddressBookContact';
    readonly fid: string;
    readonly name: string;
    readonly accountNumber: string;
  };
};

export type ExchangeRatesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ExchangeRatesQuery = {
  readonly __typename: 'Query';
  readonly exchangeRates: ReadonlyArray<{
    readonly __typename: 'ExchangeRate';
    readonly currencyCode: string;
    readonly exchangeRate: number;
  }>;
};

export type AmlRecordsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type AmlRecordsQuery = {
  readonly __typename: 'Query';
  readonly organization: {
    readonly __typename: 'Organization';
    readonly orgNum: string;
    readonly crossborderPaymentAmlRecords: ReadonlyArray<{
      readonly __typename: 'CrossborderPaymentAmlRecord';
      readonly countryCode: string;
    }>;
  };
};

export const AddressBookContactItemFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressBookContactItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AddressBookContact' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalPlace' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'used' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastTransactionDate' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastCurrencyCode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddressBookContactItemFragment, unknown>;
export const PaymentInfoFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'paymentInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'paymentFid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'creditorName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'creditorAccount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'creditorEarmarkFid' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formattedCreditorAccount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'confirmed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formattedDebtorAccount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'debtorAccount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'debtorAccountName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'debtorEarmarkFid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'estimatedNokAmount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'asNumber' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'confirmed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'structuredName' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'full' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'first' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'event' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'EventItem' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addressBookContact' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AddressBookContactItem' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'structuredName' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'full' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'first' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'structuredName' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'full' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'first' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeDeleted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'external' } },
          { kind: 'Field', name: { kind: 'Name', value: 'immutable' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountingSystemInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'systemName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'registeredBy' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ledgerAccount' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFolioInvoice' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canBeBatchApproved' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaymentInfoFragment, unknown>;
export const SalaryPaymentInfoFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'salaryPaymentInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SalaryPayment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bulkStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'paymentInfo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountingSystemInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'systemName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'registeredBy' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'debtorAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountNumber' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SalaryPaymentInfoFragment, unknown>;
export const GetPaymentsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPayments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'statusList' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'PaymentStatus' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'bulkStatusList' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'SalaryPaymentStatus' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'poll' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentsByStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'statusList' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'statusList' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'poll' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'poll' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'paymentInfo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salaryPayments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'statusList' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'bulkStatusList' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'salaryPaymentInfo' },
                },
              ],
            },
          },
        ],
      },
    },
    ...PaymentInfoFragmentDoc.definitions,
    ...EventItemFragmentDoc.definitions,
    ...ReceiptItemFragmentDoc.definitions,
    ...AnnotationItemFragmentDoc.definitions,
    ...LedgerCategoryInfoItemFragmentDoc.definitions,
    ...AddressBookContactItemFragmentDoc.definitions,
    ...SalaryPaymentInfoFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<GetPaymentsQuery, GetPaymentsQueryVariables>;
export const GetAddressBookDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAddressBook' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'orgNum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addressBook' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AddressBookContactItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AddressBookContactItemFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<GetAddressBookQuery, GetAddressBookQueryVariables>;
export const DeletePaymentDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeletePayment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'paymentFid' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePayment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentFid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'paymentFid' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'paymentInfo' },
                },
              ],
            },
          },
        ],
      },
    },
    ...PaymentInfoFragmentDoc.definitions,
    ...EventItemFragmentDoc.definitions,
    ...ReceiptItemFragmentDoc.definitions,
    ...AnnotationItemFragmentDoc.definitions,
    ...LedgerCategoryInfoItemFragmentDoc.definitions,
    ...AddressBookContactItemFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  DeletePaymentMutation,
  DeletePaymentMutationVariables
>;
export const UnapprovePaymentDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnapprovePayment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'paymentFid' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unapprovePayment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentFid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'paymentFid' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'paymentInfo' },
                },
              ],
            },
          },
        ],
      },
    },
    ...PaymentInfoFragmentDoc.definitions,
    ...EventItemFragmentDoc.definitions,
    ...ReceiptItemFragmentDoc.definitions,
    ...AnnotationItemFragmentDoc.definitions,
    ...LedgerCategoryInfoItemFragmentDoc.definitions,
    ...AddressBookContactItemFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  UnapprovePaymentMutation,
  UnapprovePaymentMutationVariables
>;
export const CreatePaymentDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePayment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'createPaymentInput' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreatePaymentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPayment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'createPaymentInput' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'createPaymentInput' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookkeepingError' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentFid' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addressBookContact' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'AddressBookContactItem',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AddressBookContactItemFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  CreatePaymentMutation,
  CreatePaymentMutationVariables
>;
export const CreateCrossborderPaymentDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCrossborderPayment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateCrossborderPaymentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCrossborderPayment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookkeepingError' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentFid' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addressBookContact' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'AddressBookContactItem',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...AddressBookContactItemFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  CreateCrossborderPaymentMutation,
  CreateCrossborderPaymentMutationVariables
>;
export const InitiatePaymentsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InitiatePayments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'paymentsInput' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'InitiatePaymentsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'initiatePayments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'initiatePaymentsInput' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'paymentsInput' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'authUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InitiatePaymentsMutation,
  InitiatePaymentsMutationVariables
>;
export const AddAmlRecordDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddAmlRecord' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'AddCrossborderPaymentAmlRecordInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addCrossborderPaymentAmlRecord' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'orgNum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'crossborderPaymentAmlRecords' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'countryCode' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddAmlRecordMutation,
  AddAmlRecordMutationVariables
>;
export const GetReceiptsForPaymentDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetReceiptsForPayment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'receiptFids' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'receipts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'receiptFids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'receiptFids' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReceiptItem' },
                },
              ],
            },
          },
        ],
      },
    },
    ...ReceiptItemFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  GetReceiptsForPaymentQuery,
  GetReceiptsForPaymentQueryVariables
>;
export const PaymentDetailsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaymentDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fid' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'paymentInfo' },
                },
              ],
            },
          },
        ],
      },
    },
    ...PaymentInfoFragmentDoc.definitions,
    ...EventItemFragmentDoc.definitions,
    ...ReceiptItemFragmentDoc.definitions,
    ...AnnotationItemFragmentDoc.definitions,
    ...LedgerCategoryInfoItemFragmentDoc.definitions,
    ...AddressBookContactItemFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<PaymentDetailsQuery, PaymentDetailsQueryVariables>;
export const SalaryPaymentDetailsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SalaryPaymentDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salaryPayment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fid' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'salaryPaymentInfo' },
                },
              ],
            },
          },
        ],
      },
    },
    ...SalaryPaymentInfoFragmentDoc.definitions,
    ...PaymentInfoFragmentDoc.definitions,
    ...EventItemFragmentDoc.definitions,
    ...ReceiptItemFragmentDoc.definitions,
    ...AnnotationItemFragmentDoc.definitions,
    ...LedgerCategoryInfoItemFragmentDoc.definitions,
    ...AddressBookContactItemFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SalaryPaymentDetailsQuery,
  SalaryPaymentDetailsQueryVariables
>;
export const DeleteSalaryPaymentDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteSalaryPayment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'bulkPaymentFid' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteSalaryPayment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'bulkPaymentFid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'bulkPaymentFid' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'salaryPaymentInfo' },
                },
              ],
            },
          },
        ],
      },
    },
    ...SalaryPaymentInfoFragmentDoc.definitions,
    ...PaymentInfoFragmentDoc.definitions,
    ...EventItemFragmentDoc.definitions,
    ...ReceiptItemFragmentDoc.definitions,
    ...AnnotationItemFragmentDoc.definitions,
    ...LedgerCategoryInfoItemFragmentDoc.definitions,
    ...AddressBookContactItemFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  DeleteSalaryPaymentMutation,
  DeleteSalaryPaymentMutationVariables
>;
export const UnapproveSalaryPaymentDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnapproveSalaryPayment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'bulkPaymentFid' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unapproveSalaryPayment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'bulkPaymentFid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'bulkPaymentFid' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'salaryPaymentInfo' },
                },
              ],
            },
          },
        ],
      },
    },
    ...SalaryPaymentInfoFragmentDoc.definitions,
    ...PaymentInfoFragmentDoc.definitions,
    ...EventItemFragmentDoc.definitions,
    ...ReceiptItemFragmentDoc.definitions,
    ...AnnotationItemFragmentDoc.definitions,
    ...LedgerCategoryInfoItemFragmentDoc.definitions,
    ...AddressBookContactItemFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  UnapproveSalaryPaymentMutation,
  UnapproveSalaryPaymentMutationVariables
>;
export const UpdatePaymentDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePayment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdatePaymentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePayment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updatePaymentInput' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'paymentInfo' },
                },
              ],
            },
          },
        ],
      },
    },
    ...PaymentInfoFragmentDoc.definitions,
    ...EventItemFragmentDoc.definitions,
    ...ReceiptItemFragmentDoc.definitions,
    ...AnnotationItemFragmentDoc.definitions,
    ...LedgerCategoryInfoItemFragmentDoc.definitions,
    ...AddressBookContactItemFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  UpdatePaymentMutation,
  UpdatePaymentMutationVariables
>;
export const DeleteAddressBookContactDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAddressBookContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAddressBookContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fid' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountNumber' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteAddressBookContactMutation,
  DeleteAddressBookContactMutationVariables
>;
export const ExchangeRatesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExchangeRates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exchangeRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currencyCode' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exchangeRate' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExchangeRatesQuery, ExchangeRatesQueryVariables>;
export const AmlRecordsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AmlRecords' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'orgNum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'crossborderPaymentAmlRecords' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'countryCode' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AmlRecordsQuery, AmlRecordsQueryVariables>;
